import { useQuery } from 'hooks/useCustomQuery';
import { axios } from '@/services/axios';

const useGetCompanyApproval = (companyId, enabled = true) =>
    useQuery({
        queryKey: ['companyApproval', companyId],
        queryFn: async () => {
            if (!companyId) return null;
            const res = await axios.get(`/company/${companyId}/approval/`);
            return res.data;
        },
        enabled: !!companyId && enabled,
        staleTime: 0,
    });

export default useGetCompanyApproval;
